import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/account.php?ctl=Login&met=doLogin&typ=json',
    method: 'get',
    params: data,
    headers:{'Content-Type' : `application/x-www-form-urlencoded`}
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}
//获取用户列表的接口 CX
export function fetchList(params) {
  return request({
    url: '/administrator.php?mdu=account&ctl=User_Info&met=lists&typ=json&user_is_admin=1&user_admin_type=1',
    method: 'get',
    params: params,

  })
}
//获取所有权限列表的接口 CX
export function fetchAdministrator(data) {
  return request({
    url: `/administrator.php?mdu=shop_admin&ctl=Rights_Group&met=lists&typ=json&rows=${data.rows}&page=${data.page}&sidx=rights_group_id&sord=desc`,
    method: 'get',
  })
}
//新增用户接口CX
export function createAdmin(data) {
  return request({
    url: '/administrator.php?mdu=account&ctl=User_Info&met=add&typ=json',
    method: 'post',
    data: data
  })
}
//新增角色CX
export function addRole(data) {
  return request({
    url: '/administrator.php?mdu=account&ctl=User_Info&met=editRightGroupIds&typ=json',
    method: 'post',
    data: data
  })
}
//修改用户CX
export function updateAdmin(data) {
  return request({
    url: '/administrator.php?mdu=account&ctl=User_Info&met=edit&typ=json',
    method: 'post',
    data: data,
    headers:{'Content-Type' : `application/x-www-form-urlencoded`}
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}
//删除用户 CX
export function deleteAdmin(data) {
  return request({
    url: '/administrator.php?mdu=account&ctl=User_Info&met=remove&typ=json',
    method: 'post',
    data:data
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js